<script>
export default {
  name: 'abstract-choose-subscription-plan',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      required: false,
      default: 'default',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/mixins/gradients';

  $background-color: #009692;

  .choose-subscription-column__choose {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .choose-subscription-column__summary {
    display: flex;
    flex: 0 1 300px;
    margin-left: 1em;
    min-width: 300px;
    flex-direction: column;
    align-items: flex-start;
    .sticky {
      width: 100%;
    }
  }

  .choose-subscription-plan {
    flex-grow: 1;
    display: flex;
    // flex-shrink: 0;
    align-self: stretch;
    flex-direction: column;

    &.is-direction-row {
      flex-direction: row;
    }


    .choose-subscription-plan__col {
      display: flex;
      align-self: stretch;
      margin-bottom: 1em;

      &.is-without-bottom-margin {
        margin-bottom: 0;
      }
    }

    .choose-subscription-plan__navigation {
      flex-grow: 1;
      display: flex;
      margin-top: 2em;
      justify-content: space-between;
    }

    .choose-subscription-plan__features {
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      .features__title {
        flex-grow: 1;
        display: flex;
        margin: 0.35em 0em 0.35em 1.15em;
        justify-content: space-between;

        &.is-without-bottom-margin {
          margin-bottom: 0;
        }

        > .features__title--text {
          color: #fff;
          text-align: left;
          font-size: 1.05em;
          font-weight: 500;
        }

        > .features__title--customize {
          border-radius: 8px;
          background-color: #fff;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          padding: 0.25em 0.75em 0.15em;
          margin-right: 1em;

          /deep/ .el-switch {
            .el-switch__label {
              color: #b4bccc;
              * {
                font-size: 0.9rem !important;
              }
              &.is-active {
                color: #009692 !important;
              }
            }
          }
        }
      }

      .features__wrap {
        flex-grow: 1;
        display: flex;
        min-height: 2em;
        position: relative;
        border-radius: 12px;
        flex-direction: column;
        border: 2px solid #fff;

        transition: all 0.10s;
        background-color: $background-color;

        &.is-transparent {
          background-color: transparent;
        }

        &.is-half-transparent {
          background-color: rgba($background-color, 0.5);
        }

        &.is-powered-by-stripe {
          background-size: 12em auto;
          background-repeat: no-repeat;
          background-position: right 1.5em bottom 1.5em;
          background-color: rgba($background-color, 0.5);
          background-image: url('~assets/images/powered_by_stripe_solid_dark.svg');
        }

        .features__wrap__extend-plan {
          color: #009692;
          font-weight: 500;
          font-size: 0.95em;
          padding: 0.35em 1em;
          background-color: #fff;
          &.is-first {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
          }
          &.is-last {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
        }

        /deep/ .el-form {

          .el-form-item {
            &:last-child {
              margin-bottom: 0;
            }
          }

          .el-row {
            margin-bottom: 0.75em;
            &:last-child {
              margin-bottom: 0;
            }
          }

          .el-cascader {
            .el-cascader__label {
              z-index: 2;
            }
          }

          .stripe-card {
            z-index: 2;
            width: 100%;
            float: left;
            height: 40px;
            border-radius: 4px;
            position: relative;
            display: inline-block;
            background-color: #fff;
            border: 1px solid #d8dce5;
            padding: 7px 2px 7px 15px;
            &.is-active {
              border-color: #409EFF;
            }
            &.is-disabled {
              pointer-events: none;
              background-color: #F7F7F7;
              border: 1px solid #F7F7F7;
              /deep/ .StripeElement {
                visibility: hidden;
              }
            }
          }

        }
        // end ~ el-form
      }

      .features__more_less {
        flex-grow: 1;
        display: flex;
        justify-content: center;
        > a {
          color: #009692;
          font-weight: 500;
          padding: 0.15em 2em 0.5em;
          font-size: 0.85rem;
          border-radius: 8px;
          background-color: #fff;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }
      }

      .features__note {
        display: flex;
        flex-direction: column;
        margin: 0.25em 1.15em;
        > .features__note--text {
          color: #fff;
          text-align: right;
          font-size: 0.85rem;
        }
      }

      &.is-show-less {
        .features__wrap {
          padding-bottom: 0.5em;
          @include gradient-vertical($background-color, #fff, calc(100% - 0.5em) , calc(100% - 0.5em));
          > *:nth-child(n+7) {
            display: none;
          }
        }
      }
    }

    &.theme-gray {
      height: 100%;
      flex: 1 1 auto;
      padding: 1em;

      .features__wrap {
        border-color: #607d8b;
        background-color: #fff;
        .features__wrap__extend-plan {
          color: #fff;
          background-color: #607d8b;
        }
      }

      .features__more_less {
        > a {
          color: #fff;
          background-color: #607d8b;
        }
      }

      .choose-subscription-plan__features {
        .features__title {
          > .features__title--text {
            color: #607d8b;
          }
          > .features__title--customize {
            /deep/ .el-switch {
              .el-switch__label {
                &.el-switch__label--right {
                  color: #607d8b;
                  &.is-active {
                    color: #607d8b !important;
                  }
                }
              }
            }
          }
        }
        &.is-show-less {
          .features__wrap {
            @include gradient-vertical(transparent, #607d8b, calc(100% - 0.5em) , calc(100% - 0.5em));
            > *:nth-child(n+7) {
              display: none;
            }
          }
        }
      } // end ~ choose-subscription-plan__features
    }
    // end ~ theme-gray

    &.theme-topography, .nuttrema-theme-professional-topography & {

      // .features__wrap {
      //   border-color: #465568;
      //   background-color: rgba(#fff, 0.75);
      //   .features__wrap__extend-plan {
      //     color: #465568;
      //     background-color: #dbdbdb;
      //   }
      // }

      .features__more_less {
        > a {
          color: #465568;
          background-color: #dbdbdb;
        }
      }

      .choose-subscription-plan__features {

        .features__title {
          > .features__title--text {
            color: #465568;
          }
          > .features__title--customize {
            background-color: #dbdbdb;

            /deep/ .el-switch {
              .el-switch__label {
                &.el-switch__label--right {
                  color: #465568;
                  &.is-active {
                    color: #465568 !important;
                  }
                }
              }
            }
          }
        }

        .features__wrap {
          border-color: #dbdbdb;
          background: rgba(#fff, 0.85);
          .features__wrap__extend-plan {
            color: #465568;
            background-color: #dbdbdb;
          }

          &.is-powered-by-stripe {
            background-repeat: no-repeat;
            background-color: rgba(#fff, 0.75);
            background-position: right 1.5em bottom 1.5em;
            background-image: url('~assets/images/powered_by_stripe_solid_dark.svg');
          }
        }

        &.is-show-less {
          .features__wrap {
            @include gradient-vertical(transparent, #dbdbdb, calc(100% - 0.5em) , calc(100% - 0.5em));
            > *:nth-child(n+7) {
              display: none;
            }
          }
        }

      }
      // end ~ .choose-subscription-plan__features

    }
    // end ~ theme-topography

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/subscription/abstract-choose-subscription-plan.vue